import { createSvgIcon } from "@mui/material";

const FormatParagraph = createSvgIcon(
  <path d="M 12 6 V 21 H 10 V 16 C 6.6863 16 4 13.3137 4 10 C 4 6.6863 6.6863 4 10 4 H 20 V 6 H 17 V 21 H 15 V 6 H 12 Z Z"></path>,
  "FormatParagraph"
);

export default FormatParagraph;
